export default {"src":"/_next/static/media/soundcloud.d773feaa.svg","height":64,"width":64};